import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { ICompany } from '../models/models'

export class GetCompanyApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/company-list',
      requesterInfo,
    })
  }

  public async getCompany(): Promise<ICompany[]> {
    return await this.getAsync<ICompany[]>()
  }
}
